<!-- SiteFooter.vue -->
<template>
  <footer class="nebula-site-footer">
    <div v-if="isLoading" class="nebula-footer-skeleton">
      <!-- 스켈레톤 UI -->
      <div class="skeleton skeleton-banner"></div>
      <div class="skeleton skeleton-menu"></div>
      <div class="skeleton skeleton-company"></div>
<!--      <div class="skeleton skeleton-customer"></div>-->
<!--      <div class="skeleton skeleton-badges"></div>-->
      <div class="skeleton skeleton-copyright"></div>
    </div>

    <div v-else>
      <!-- 상단 배너 (보톡스 광고) -->
<!--      <div class="nebula-footer-banner">-->
<!--        <div class="nebula-container">-->
<!--          <img :src="require('@/assets/user/footer/하단_띠배너.png')" alt="하단 띠배너" />-->
<!--        </div>-->
<!--      </div>-->

      <!-- 회사 메뉴 -->
      <div class="nebula-company-menu">
        <div class="nebula-container">
          <ul class="nebula-menu-list">
            <li class="nebula-menu-item"><a href="#" @click.prevent="openModal('company')">회사소개</a></li>
            <li class="nebula-menu-item"><a href="#" @click.prevent="openModal('terms')">이용약관</a></li>
            <li class="nebula-menu-item"><a href="#" @click.prevent="openModal('privacy')">개인정보처리방침</a></li>
            <li class="nebula-menu-item"><a href="#" @click.prevent="openModal('guide')">이용안내</a></li>
          </ul>
        </div>
      </div>

      <!-- 모달 -->
      <div class="footer-modal-overlay" v-if="showModal" @click.self="closeModal">
        <div class="footer-modal">
          <div class="footer-modal-header">
            <h3>{{ modalTitle }}</h3>
            <button class="footer-modal-close" @click="closeModal">&times;</button>
          </div>
          <div class="footer-modal-body">
            <!-- 회사소개 -->
            <div v-if="modalType === 'company'" class="modal-content-section">
              <div class="company-info-block">
                <h4>회사 정보</h4>
                <table class="info-table">
                  <tr>
                    <th>상호</th>
                    <td>{{ storeConfig.name || '마이툴' }}</td>
                  </tr>
                  <tr>
                    <th>대표</th>
                    <td>{{ storeConfig.ceoName || '박희천' }}</td>
                  </tr>
                  <tr>
                    <th>주소</th>
                    <td>{{ getFullAddress() || '서울 구로구 경인로53길 90 1505호' }}</td>
                  </tr>
                  <tr>
                    <th>사업자등록번호</th>
                    <td>{{ storeConfig.businessNumber || '113-81-74883' }}</td>
                  </tr>
                  <tr>
                    <th>이메일</th>
                    <td>{{ storeConfig.email || 'mytool@mytool.co.kr' }}</td>
                  </tr>
                  <tr>
                    <th>개인정보책임관리자</th>
                    <td>{{ storeConfig.ceoName || '박희천' }}</td>
                  </tr>
                </table>
              </div>
              <div class="company-info-block">
                <h4>고객센터</h4>
                <table class="info-table">
                  <tr>
                    <th>운영시간</th>
                    <td>월요일 - 금요일 09:00 ~ 18:00 (점심시간 12:00 ~ 13:00)</td>
                  </tr>
                  <tr>
                    <th>전화번호</th>
                    <td>{{ storeConfig.phone || '070-7010-6230' }}</td>
                  </tr>
                  <tr>
                    <th>팩스</th>
                    <td>02-2611-2067</td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- 이용약관 -->
            <div v-if="modalType === 'terms'" class="modal-content-section">
              <div class="terms-content">
                <h4>제1조 (목적)</h4>
                <p>이 약관은 마이툴(이하 "회사")이 운영하는 온라인 쇼핑몰에서 제공하는 서비스를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>

                <h4>제2조 (정의)</h4>
                <p>1. "쇼핑몰"이란 회사가 상품 또는 서비스를 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 상품 또는 서비스를 거래할 수 있도록 설정한 가상의 영업장을 말합니다.</p>
                <p>2. "이용자"란 쇼핑몰에 접속하여 이 약관에 따라 쇼핑몰이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</p>

                <h4>제3조 (약관의 효력 및 변경)</h4>
                <p>1. 이 약관은 쇼핑몰 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</p>
                <p>2. 회사는 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</p>

                <h4>제4조 (서비스의 제공)</h4>
                <p>회사는 다음과 같은 서비스를 제공합니다.</p>
                <p>1. 상품 또는 서비스에 대한 정보 제공 및 구매계약의 체결</p>
                <p>2. 구매계약이 체결된 상품 또는 서비스의 배송</p>
                <p>3. 기타 회사가 정하는 업무</p>
              </div>
            </div>

            <!-- 개인정보처리방침 -->
            <div v-if="modalType === 'privacy'" class="modal-content-section">
              <div class="privacy-content">
                <h4>1. 개인정보의 처리 목적</h4>
                <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                <p>- 회원 가입 및 관리</p>
                <p>- 서비스 제공 및 계약 이행</p>
                <p>- 마케팅 및 광고에의 활용</p>

                <h4>2. 개인정보의 처리 및 보유기간</h4>
                <p>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>

                <h4>3. 개인정보의 제3자 제공</h4>
                <p>회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등의 경우에만 개인정보를 제3자에게 제공합니다.</p>

                <h4>4. 개인정보처리의 위탁</h4>
                <p>회사는 원활한 개인정보 업무처리를 위하여 일부 개인정보 처리업무를 위탁하고 있습니다.</p>

                <h4>5. 개인정보의 파기</h4>
                <p>회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
              </div>
            </div>

            <!-- 이용안내 -->
            <div v-if="modalType === 'guide'" class="modal-content-section">
              <div class="guide-content">
                <h4>주문 안내</h4>
                <p>1. 회원가입 후 원하시는 상품을 장바구니에 담아주세요.</p>
                <p>2. 장바구니에서 상품을 확인하신 후 주문하기 버튼을 클릭해주세요.</p>
                <p>3. 배송지 정보와 결제 방법을 선택하신 후 결제를 완료해주세요.</p>

                <h4>배송 안내</h4>
                <p>- 배송비: 기본 배송비는 상품에 따라 다르며, 일정 금액 이상 구매 시 무료배송됩니다.</p>
                <p>- 배송기간: 결제 완료 후 1~3일 이내 출고됩니다. (주말/공휴일 제외)</p>
                <p>- 도서산간 지역은 추가 배송비가 발생할 수 있습니다.</p>

                <h4>교환/반품 안내</h4>
                <p>- 교환/반품 신청은 상품 수령 후 7일 이내에 가능합니다.</p>
                <p>- 단순 변심에 의한 교환/반품 시 왕복 배송비는 고객 부담입니다.</p>
                <p>- 상품 하자 및 오배송의 경우 배송비는 회사에서 부담합니다.</p>

                <h4>결제 안내</h4>
                <p>- 신용카드, 계좌이체, 가상계좌, 여신결제 등 다양한 결제 수단을 지원합니다.</p>
                <p>- 세금계산서 발행이 필요하신 경우 고객센터로 문의해주세요.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 회사 정보 -->
      <div class="nebula-company-info">
        <div class="nebula-container">
          <div class="nebula-info-grid">
            <!-- 회사 로고 및 정보 -->
            <div class="nebula-company-details">
              <div class="nebula-company-logo">
                <img v-if="storeConfig.logoUrl" :src="getImageUrl(storeConfig.logoUrl)" alt="회사 로고">
                <img v-else src="@/assets/images/toolstar_logo.png" alt="기본 로고">
              </div>
              <div><a href="#" class="nebula-company-intro-btn">회사소개서</a></div>
            </div>
            <div class="nebula-company-text">
              <p>상호 : {{ storeConfig.name || '(주)마이툴' }} | 대표 : {{ storeConfig.ceoName || '박희천' }}</p>
              <p>주소 : {{ getFullAddress() }}</p>
              <p>사업자등록번호 : {{ storeConfig.businessNumber || '113-81-74883' }}</p>
<!--              <p>통신판매업신고 : 제 2020-진접오남-0339 호</p>-->
              <p>이메일 : {{ storeConfig.email || ' mytool@mytool.co.kr' }}</p>
              <p>개인정보책임관리자 : {{ storeConfig.ceoName || '박희천' }}</p>
            </div>
            <!-- 고객센터 정보 -->
            <div class="nebula-customer-center">
              <div class="nebula-center-header">
                <div class="nebula-center-icon">
                  <img src="@/assets/user/footer/free-icon-apple-831309.png" alt="임시 이미지">
                </div>
                <h3 class="nebula-center-title">고객센터</h3>
              </div>
              <div class="nebula-center-info">
                <p>운영시간 : 월요일 - 금요일 09:00 ~ 18:00 (점심시간 12:00 ~ 13:00)</p>
                <p>TEL. {{ storeConfig.phone || '070-7010-6230' }} | FAX. 02-2611-2067</p>
              </div>

              <!-- 문의 버튼 -->
              <div class="nebula-contact-buttons">
                <a href="#" class="nebula-contact-btn">
                  <div class="nebula-contact-icon">
                    <img src="@/assets/user/footer/free-icon-chat-bot-8649607.png" alt="임시 이미지">
                  </div>
                  <span>채팅문의</span>
                </a>
                <a href="#" class="nebula-contact-btn">
                  <div class="nebula-contact-icon">
                    <img src="@/assets/user/footer/free-icon-chat-bot-8794620.png" alt="임시 이미지">
                  </div>
                  <span>전화문의</span>
                </a>
                <a href="#" class="nebula-contact-btn">
                  <div class="nebula-contact-icon">
                    <img src="@/assets/user/footer/free-icon-fax-machine-5075753.png" alt="임시 이미지">
                  </div>
                  <span>FAX문의</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 인증 배지 -->
<!--      <div class="nebula-certifications">-->
<!--        <div class="nebula-container">-->
<!--          <div class="nebula-badges">-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo1.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo2.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo3.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo4.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <!-- 저작권 정보 -->
      <div class="nebula-copyright">
        <div class="nebula-container">
          <p>© 2025 {{ storeConfig.name || 'Mytool' }}. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getStoreConfig } from '@/services/storeConfigService';

export default {
  name: 'SiteFooter',
  data() {
    return {
      isLoading: true,
      showModal: false,
      modalType: '',
      storeConfig: {
        name: '',
        ceoName: '',
        businessNumber: '',
        phone: '',
        email: '',
        address1: '',
        address2: '',
        zipCode: '',
        logoUrl: ''
      },
      baseURL: process.env.NODE_ENV === 'production'
          ? 'https://mytoolb2b.link'
          : 'http://localhost:8080'
    };
  },
  computed: {
    modalTitle() {
      const titles = {
        company: '회사소개',
        terms: '이용약관',
        privacy: '개인정보처리방침',
        guide: '이용안내'
      };
      return titles[this.modalType] || '';
    }
  },
  async mounted() {
    await this.loadStoreConfig();
  },
  methods: {
    openModal(type) {
      this.modalType = type;
      this.showModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.showModal = false;
      this.modalType = '';
      document.body.style.overflow = '';
    },
    async loadStoreConfig() {
      try {
        this.isLoading = true;

        const store = await getStoreConfig();

        if (store) {
          this.storeConfig = {
            ...this.storeConfig,
            ...store
          };
          console.log('회사 정보 로드 완료:', this.storeConfig);
        }
      } catch (error) {
        console.error('회사 정보 로드 실패:', error);
        // 에러 발생 시 기본값 유지
      } finally {
        this.isLoading = false;
      }
    },

    getFullAddress() {
      const parts = [];
      if (this.storeConfig.address1) parts.push(this.storeConfig.address1);
      if (this.storeConfig.address2) parts.push(this.storeConfig.address2);

      return parts.length > 0
          ? parts.join(' ')
          : '경기도 남양주시 진접읍 금강로 1133';
    },

    getImageUrl(imageUrl) {
      if (!imageUrl) return '';

      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl;
      }

      return `${this.baseURL}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
    }
  }
};
</script>

<style scoped>
.nebula-site-footer {
  font-family: 'Noto Sans KR', sans-serif;
  color: #333;
}

.nebula-container {
  max-width: 1370px;
  margin: 0 auto;
  padding: 0 15px;
}
.nebula-container img {
  max-width: 100%;
  margin: 0 auto;
}
/* 상단 배너 */
.nebula-footer-banner {
  background-color: #17001C;
  padding: 0;
}

.nebula-banner-img {
  width: 100%;
  display: block;
}

/* 회사 메뉴 */
.nebula-company-menu {
  background-color: #f0f0f0;
  padding: 15px 0;
}

.nebula-menu-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.nebula-menu-item {
  margin-right: 20px;
}

.nebula-menu-item a {
  color: #333;
  text-decoration: none;
  font-size: 14px;
}

.nebula-menu-item a:hover {
  text-decoration: underline;
}

/* 회사 정보 */
.nebula-company-info {
  background-color: #f8f8f8;
  padding: 30px 0;
}

.nebula-info-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
}

.nebula-company-details {
  flex: 2;
  max-width: 25%;
  position: relative;
}

.nebula-company-logo {
  margin-bottom: 15px;
}

.nebula-company-logo img {
  max-width: 200px;
}

.nebula-company-text p {
  margin: 5px 0;
  font-size: 13px;
  color: #666;
}

.nebula-company-intro-btn {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  padding: 8px 15px;
  background-color: #555;
  color: #fff;
  font-size: 13px;
  text-decoration: none;
  border-radius: 3px;
}

.nebula-company-intro-btn:hover {
  background-color: #444;
}

/* 고객센터 정보 */
.nebula-customer-center {
  flex: 1;
  max-width: 30%;
  padding: 0 15px;
}

.nebula-center-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.nebula-center-icon {
  margin-right: 8px;
}

.nebula-center-icon img {
  width: 24px;
  height: 24px;
}

.nebula-center-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.nebula-center-info p {
  margin: 5px 0;
  font-size: 13px;
  color: #666;
}

/* 문의 버튼 */
.nebula-contact-buttons {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.nebula-contact-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  flex: 1;
  padding: 15px 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.nebula-contact-icon {
  margin-bottom: 8px;
}

.nebula-contact-icon img {
  width: 30px;
  height: 30px;
}

.nebula-contact-btn span {
  font-size: 12px;
  color: #333;
}

/* 인증 배지 */
.nebula-certifications {
  background-color: #fff;
  padding: 20px 0;
  border-top: 1px solid #eee;
}

.nebula-badges {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0px;
}

.nebula-badge {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 265px;
  border: 0px solid #eee;
  padding: 50px 0px;
  border-radius: 5px;
}

.nebula-badge img {
  margin-right: 0px;
}

.nebula-badge-text p {
  margin: 3px 0;
  font-size: 11px;
  color: #777;
}

/* 저작권 정보 */
.nebula-copyright {
  background-color: #f0f0f0;
  padding: 15px 0;
  text-align: center;
}

.nebula-copyright p {
  margin: 0;
  font-size: 12px;
  color: #999;
}

/* 스켈레톤 공통 */
/* 기본 스타일 유지 */
.nebula-site-footer {
  font-family: 'Noto Sans KR', sans-serif;
  color: #333;
}

/* 스켈레톤용 스타일 */
.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: pulse 1.5s ease-in-out infinite;
  border-radius: 6px;
  margin-bottom: 10px;
}

.skeleton-banner {
  height: 80px;
  margin: 10px 0;
}

.skeleton-menu {
  height: 50px;
  margin: 10px 0;
}

.skeleton-company {
  height: 220px;
}

.skeleton-customer {
  height: 160px;
}

.skeleton-badges {
  height: 140px;
}

.skeleton-copyright {
  height: 40px;
  margin-top: 10px;
}

@keyframes pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* 반응형 스타일 */
@media (max-width: 992px) {
  .nebula-info-grid {
    flex-direction: column;
  }

  .nebula-company-details,
  .nebula-customer-center {
    max-width: 100%;
  }

  .nebula-badges {
    justify-content: center;
  }

  .nebula-badge {
    flex: 0 0 calc(50% - 15px);
  }

}

@media (max-width: 768px) {
  .nebula-company-details {
    padding-bottom: 20px;
  }

  .nebula-company-intro-btn {
    position: static;
    margin-top: 15px;
  }

  .nebula-badges {
   display: none;
  }
}

@media (max-width: 576px) {
  .nebula-menu-list {
    flex-wrap: wrap;
  }

  .nebula-menu-item {
    margin-bottom: 5px;
  }

  .nebula-contact-buttons {
    flex-wrap: wrap;
  }

  .nebula-contact-btn {
    flex: 0 0 calc(33.33% - 10px);
  }
}

/* 푸터 모달 스타일 */
.footer-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.footer-modal {
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: modalSlideIn 0.3s ease;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.footer-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  background-color: #f8f8f8;
}

.footer-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.footer-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #666;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.footer-modal-close:hover {
  color: #333;
}

.footer-modal-body {
  padding: 20px;
  overflow-y: auto;
  max-height: calc(80vh - 60px);
}

.modal-content-section {
  font-size: 14px;
  line-height: 1.7;
  color: #555;
}

.company-info-block {
  margin-bottom: 25px;
}

.company-info-block h4 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e74c3c;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table th,
.info-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.info-table th {
  width: 140px;
  background-color: #f9f9f9;
  font-weight: 500;
  color: #555;
}

.info-table td {
  color: #333;
}

.terms-content h4,
.privacy-content h4,
.guide-content h4 {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 20px 0 10px 0;
}

.terms-content h4:first-child,
.privacy-content h4:first-child,
.guide-content h4:first-child {
  margin-top: 0;
}

.terms-content p,
.privacy-content p,
.guide-content p {
  margin: 8px 0;
  color: #555;
}

@media (max-width: 576px) {
  .footer-modal {
    width: 95%;
    max-height: 90vh;
  }

  .footer-modal-body {
    max-height: calc(90vh - 60px);
  }

  .info-table th {
    width: 100px;
    font-size: 13px;
  }

  .info-table td {
    font-size: 13px;
  }
}
</style>